import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
import classes from './index.module.scss';
const keyMap = [
    { num: '1', digit: '1', alpha: '' },
    { num: '2', digit: '2', alpha: 'ABC' },
    { num: '3', digit: '3', alpha: 'DEF' },
    { num: '4', digit: '4', alpha: 'GHI' },
    { num: '5', digit: '5', alpha: 'JKL' },
    { num: '6', digit: '6', alpha: 'MNO' },
    { num: '7', digit: '7', alpha: 'PQRS' },
    { num: '8', digit: '8', alpha: 'TUV' },
    { num: '9', digit: '9', alpha: 'WXYZ' },
    { num: '*', digit: '\ufe61', alpha: '' },
    { num: '0', digit: '0', alpha: '+' },
    { num: '#', digit: '#', alpha: '' },
];
const validKeyCodes = keyMap.map(({ num }) => num);
const KeyPad = ({ className, onInput }) => {
    const [keysPressed, setKeysPressed] = React.useState('');
    React.useEffect(() => {
        const handleKeydown = ({ key, target }) => {
            if (target.tagName === 'INPUT') {
                return;
            }
            if (validKeyCodes.includes(key)) {
                setKeysPressed(keysPressed + key);
                onInput(key);
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return () => document.removeEventListener('keydown', handleKeydown);
    }, [onInput, keysPressed, setKeysPressed]);
    const lengthBeforeTruncate = 25;
    const formattedKeysPressed = keysPressed.length >= lengthBeforeTruncate
        ? '...' + keysPressed.substr(-lengthBeforeTruncate)
        : keysPressed;
    return (_jsxs("div", Object.assign({ className: classNames(classes.keyPad, className) }, { children: [_jsx("div", Object.assign({ className: classes.keysPressed }, { children: formattedKeysPressed }), void 0), _jsx("div", Object.assign({ className: classes.keyPadKeys }, { children: keyMap.map(keyDef => (_jsxs("button", Object.assign({ className: classNames(classes.keyPadKey), "data-test": `key${keyDef.num}`, onClick: () => {
                        setKeysPressed(keysPressed + keyDef.num);
                        onInput(keyDef.num);
                    }, type: "button" }, { children: [_jsx("span", Object.assign({ className: classes.keyPadKeyDigit }, { children: keyDef.digit }), void 0), _jsx("span", Object.assign({ className: classes.keyPadKeyAlpha }, { children: keyDef.alpha }), void 0)] }), keyDef.num))) }), void 0)] }), void 0));
};
export default KeyPad;
//# sourceMappingURL=index.js.map